var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ModalsController"},[_vm._l((_vm.modalsOpen),function(modal){return _c(modal,{key:modal,ref:modal,refInFor:true,tag:"component"})}),_c('confirm-delete')],2)}
var staticRenderFns = []

export { render, staticRenderFns }